/* @flow */
import cx from 'classnames';
import * as React from 'react';
import PropTypes from 'prop-types';

import GroupMembership from 'entities/GroupMembership';
import ModalTrigger from 'components/ModalTrigger.jsx';
import RelationshipModal from 'user/components/RelationshipModal.jsx';
import Text from 'components/Text.jsx';
import UserAvatar from 'users/components/UserAvatar.jsx';
import UserLink from 'users/components/UserLink.jsx';

import './styles/GroupMemberListItem.scss';

class GroupMembershipListItem extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    classMember: PropTypes.instanceOf(GroupMembership).isRequired,
    highlight: PropTypes.bool,
    owner: PropTypes.bool,
  };

  render() {
    const name = this.props.classMember.getName();
    const member = this.props.classMember;
    const user = this.props.classMember.getUser();

    return (
      <li
        className={cx(
          {
            GroupMemberListItem: true,
            'GroupMemberListItem-highlight': this.props.highlight,
          },
          this.props.className
        )}>
        <UserLink
          className="GroupMemberListItem-link"
          userId={member.getUserId()}
          placement="left"
          alignment="top">
          <ModalTrigger modal={<RelationshipModal userId={member.getUserId()} />}>
            <span className="GroupMemberListItem-link-trigger">
              <UserAvatar
                className="GroupMemberListItem-droplet"
                size="medium"
                user={user.toJSON()}
              />
              <Text className="GroupMemberListItem-name">{name}</Text>
            </span>
          </ModalTrigger>
        </UserLink>
      </li>
    );
  }
}

export default GroupMembershipListItem;
